import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import EditMailboxSelectionFormContainer from '../containers/EditMailboxSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class EditMailboxSelectionModal extends Component {
  onSubmitSaveSelection = ({ name }) => {
    const condition = this.props.selections.map(sel => sel.name).includes(name !== undefined ? name.trim() : '');
    if (condition) {
      this.props.updateUI('error', 'app.admin.edit.preset.warning.message');
    } else {
      this.props.saveSelection({
        name,
        checkedMailboxes: this.props.checkedMailboxes,
      });
    }
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.edit.mailbox.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <EditMailboxSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          selections={this.props.selections}
          checkedMailboxes={this.props.checkedMailboxes}
          name={this.props.name}
        />
      </Modal>
    );
  }
}

EditMailboxSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    ediMailboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  checkedMailboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  name: PropTypes.string,
};

export default (EditMailboxSelectionModal);
